import { render, staticRenderFns } from "./ConfigurationPersonnelGrid.vue?vue&type=template&id=366e048e&"
import script from "./ConfigurationPersonnelGrid.vue?vue&type=script&lang=js&"
export * from "./ConfigurationPersonnelGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports